import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppImage } from '../../hooks';
import { styled } from '../../utils';
import { Card, CardContent } from '../Card';
import { FormFlex } from '../FormGrid/FormFlex';
import { FormGrid } from '../FormGrid/FormGrid';
import { Tooltip } from '../Tooltip/Tooltip';
import { Typography } from '../Typography/Typography';
const ButtonStyled = styled('button')({
    all: 'unset',
    width: '100%',
    display: 'grid',
    height: '100%',
});
const CardStyled = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'disabled' && prop !== 'error',
})(({ theme, selected, disabled, error }) => ({
    '&.MuiCard-root': {
        ...(error &&
            !disabled && { border: `1px solid ${theme.palette.error.main}` }),
        ...(selected && { border: `1px solid ${theme.palette.primary.main}` }),
        '&:hover': {
            ...(!disabled && {
                background: theme.palette.groupPrimary.lightDove,
                cursor: 'pointer',
            }),
        },
    },
}));
const TypographyStyled = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'disabled',
})(({ disabled }) => ({
    ...(disabled && { opacity: 0.5 }),
}));
export function SelectableCard({ label, image, selected, onClick, disabled, error, description, align, tooltip, }) {
    const AppImage = useAppImage();
    return (_jsx(ButtonStyled, { disabled: disabled, onClick: onClick, children: _jsx(CardStyled, { selected: selected, disabled: disabled, error: error, children: _jsxs(CardContent, { children: [tooltip && _jsx(Tooltip, { description: tooltip, size: "medium" }), _jsxs(FormFlex, { rowGap: 0, columnGap: 0, flexDirection: "column", align: align, children: [image && (_jsx(AppImage, { src: image, height: "80", width: "80", alt: label, sx: { opacity: disabled ? 0.5 : 1 } })), _jsxs(FormGrid, { rowGap: 2, children: [_jsx(FormFlex, { rowGap: 0, columnGap: 1, justifyContent: "center", align: "center", children: _jsx(TypographyStyled, { variant: "subtitle1", disabled: disabled, align: "center", children: label }) }), description && (_jsx(FormFlex, { rowGap: 0, columnGap: 0, justifyContent: "center", children: _jsx(TypographyStyled, { variant: "subtitle2", disabled: disabled, align: "center", children: description }) }))] })] })] }) }) }));
}
